export * from "./core";
export * from "./react";
export { ExperimentTrackingData, FetchDatafile } from "./types";

declare global {
  interface Window {
    REAPackageVersions?: Record<string, string[]>;
  }
}

if (typeof window === "object") {
  window.REAPackageVersions = window.REAPackageVersions || {};
  window.REAPackageVersions["@rea-argonaut/experiment"] =
    window.REAPackageVersions["@rea-argonaut/experiment"] || [];
  window.REAPackageVersions["@rea-argonaut/experiment"].push(
    "__@rea-argonaut/experiment/version__",
  );
}
